import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { useParams } from 'react-router-dom'
import { useWebChatStore } from '@/stores'
import WebChatWidget from '@/components/webchat/WebChatWidget'

const WebChatPage = observer(() => {
  const { tenantId } = useParams<{ tenantId: string }>()
  const store = useWebChatStore()

  useEffect(() => {
    if (tenantId) {
      store.tenantId = tenantId
    }
  }, [tenantId, store])

  // Embedded widget: keep the iframe background transparent so the host page
  // shows through around the floating button.
  useEffect(() => {
    const previous = document.body.style.background
    document.body.style.background = 'transparent'
    document.documentElement.style.background = 'transparent'
    return () => {
      document.body.style.background = previous
      document.documentElement.style.background = ''
    }
  }, [])

  return <WebChatWidget />
})

export default WebChatPage
